export default {
    activateText: '松开立即刷新',
    deactivateText: '下拉可以刷新',
    finishText: '完成刷新',
};



// WEBPACK FOOTER //
// ./components/pull-to-refresh/locale/zh_CN.tsx